import { useState } from 'react'

import { Trans } from '@/components'
import { Dropdown } from '@/components/base/Dropdown'

type BulkAction = 'assign' | 'suspend' | 'delete'

export function BulkDropdown({
  onAssignCredits,
  onSuspendAccount,
  onDeleteAccounts,
  disabled = false,
}: {
  onAssignCredits?: () => void
  onSuspendAccount?: () => void
  onDeleteAccounts?: () => void
  disabled?: boolean
}) {
  const TRIGGER_VALUE = '__bulk__'
  const [val, setVal] = useState<string | number>(TRIGGER_VALUE)

  return (
    <Dropdown
      rootClassName="inline-block w-[140px]"
      className="h-10 px-3 rounded-lg border border-neutral-200 bg-panel-white t-sb"
      menuClassName="w-48"
      placement="right"
      disabled={disabled}
      options={[
        {
          label: <Trans i18nKey="team.member.bulkEditTitle">Bulk Edit</Trans>,
          value: TRIGGER_VALUE,
          disabled: true,
        },
        {
          label: <Trans i18nKey="team.member.assignCredits">Assign Credits</Trans>,
          value: 'assign',
          separatorBefore: true,
        },
        // { label: 'Suspend Account', value: 'suspend' }, //hide since no api support bulk suspend
        // { label: 'Delete Accounts', value: 'delete', className: 'text-danger' }, //hide since no api support bulk delete
      ]}
      value={val}
      onChange={(next) => {
        if (next === TRIGGER_VALUE) return
        switch (next as BulkAction) {
          case 'assign':
            onAssignCredits?.()
            break
          case 'suspend':
            onSuspendAccount?.()
            break
          case 'delete':
            onDeleteAccounts?.()
            break
        }
        setTimeout(() => setVal(TRIGGER_VALUE), 0)
      }}
    />
  )
}
